import { GrTechnology } from 'react-icons/gr';
import { useTranslate } from 'react-translate';

const ICONS = {
  languages: (
    <svg viewBox='0 0 24 24' fill='none' strokeWidth='2.2' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M9 6 3 12l6 6M15 6l6 6-6 6'></path>
    </svg>
  ),
  frontend: (
    <svg viewBox='0 0 24 24' fill='none' strokeWidth='2.2' strokeLinecap='round' strokeLinejoin='round'>
      <rect x='3' y='4' width='18' height='16' rx='2.5'></rect>
      <path d='M3 9h18'></path>
    </svg>
  ),
  backend: (
    <svg viewBox='0 0 24 24' fill='none' strokeWidth='2.2' strokeLinecap='round' strokeLinejoin='round'>
      <ellipse cx='12' cy='5.5' rx='8' ry='3'></ellipse>
      <path d='M4 5.5v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6'></path>
      <path d='M4 11.5v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6'></path>
    </svg>
  ),
  tools: (
    <svg viewBox='0 0 24 24' fill='none' strokeWidth='2.2' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.8 2.8-2-2 2.8-2.8Z'></path>
    </svg>
  ),
};

const Tech = () => {
  const t = useTranslate('Technologies');

  const categories = [
    {
      icon: 'languages',
      title: t('languages'),
      subTitle: t('languages_sub'),
      techs: ['JavaScript', 'TypeScript', 'Python', 'Java', 'Swift'],
      wide: true,
    },
    {
      icon: 'frontend',
      title: t('front_end'),
      subTitle: t('front_end_sub'),
      techs: [
        'React',
        'Next.js',
        'Angular',
        'Tailwind CSS',
        'JavaScript',
        'TypeScript',
        'Astro',
        'SwiftUI',
      ],
    },
    {
      icon: 'backend',
      title: t('back_end'),
      subTitle: t('back_end_sub'),
      techs: [
        'Node.js',
        'Express',
        'Supabase',
        'Spring Boot',
        'GraphQL',
        'PostgreSQL',
        'MongoDB',
        'MySQL',
        'WordPress',
      ],
    },
    {
      icon: 'tools',
      title: t('tools'),
      subTitle: t('tools_sub'),
      techs: [
        'Docker',
        'AWS',
        'Stripe',
        'Mapbox API',
        'OpenAI API',
        'Squareup API',
        'Google APIs',
        'Git',
        'GitHub',
        'N8N',
        'Vercel',
        'Netlify',
      ],
    },
  ];

  return (
    <section id='tech' className='py-8 md:py-12'>
      <div className='section-shell'>
        <div className='mb-10 max-w-2xl'>
          <div
            className='section-kicker'
            data-aos='fade-up'
            data-aos-delay='50'
          >
            <GrTechnology />
            {t('title')}
          </div>
          <h2
            className='section-title mt-6'
            data-aos='fade-up'
            data-aos-delay='100'
          >
            {t('headline')}
          </h2>
          <p
            className='section-copy mt-5'
            data-aos='fade-up'
            data-aos-delay='150'
          >
            {t('sub_title')}
          </p>
        </div>

        <div className='grid gap-5 md:grid-cols-2 lg:grid-cols-3'>
          {categories.map((category, index) => (
            <div
              key={category.title}
              className={`cat-card ${category.wide ? 'lg:col-span-3' : ''}`}
              data-aos='fade-up'
              data-aos-delay={index * 80}
            >
              <div className='icon-badge'>{ICONS[category.icon]}</div>
              <p className='mt-4 text-sm font-extrabold tracking-[0.02em] text-[var(--text-main)]'>
                {category.title}
              </p>
              <p className='mt-1.5 text-[13.5px] text-[var(--text-soft)]'>
                {category.subTitle}
              </p>
              <div className='mt-5 flex flex-wrap gap-2.5'>
                {category.techs.map((tech) => (
                  <span key={tech} className='tag-chip'>
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Tech;
